/**
 * External dependencies
 */

/**
 * WordPress dependencies.
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';

const Edit = ( props ) => {
	const { isSelected } = props;
	const blockProps = useBlockProps();

	return <div { ...blockProps } >
		{ isSelected && <Inspector { ...props } /> }
		<InnerBlocks renderAppender={ InnerBlocks.ButtonBlockAppender } />
	</div>;
};

export default Edit;
